import React, { type FC } from "react";
import type { RouteComponentProps } from "react-router-dom";
import type { InboundDocumentPageRequest } from "src/api/interfaces/inbound_document";
import AICLayout from "src/components/AICLayout/AICLayout";
import { DocumentComplianceContextProvider } from "src/components/Contexts/DocumentComplianceContext";
import { InboundDocumentContextProvider } from "src/components/Contexts/InboundDocumentContext";
import { UserActionsMetadataContextProvider } from "src/components/Contexts/UserActionsMetadata/Provider";
import { ValidationResultsContextProvider } from "src/components/Contexts/ValidationResultsContext";
import { DocumentComplianceHelperProvider } from "src/components/Pages/DocumentInbound/DocumentComplianceHelper/DocumentComplianceHelperContext";
import DocumentComplianceHelperPanel from "src/components/Pages/DocumentInbound/DocumentComplianceHelper/DocumentComplianceHelperPanel";
import InboundDocumentFetcher from "src/components/Pages/DocumentInbound/InboundDocumentFetcher";
import InboundDocumentHeader from "src/components/Pages/DocumentInbound/InboundDocumentHeader";
import InboundDocumentNavbar from "src/components/Pages/DocumentInbound/InboundDocumentNavbar";
import styles from "src/styles.module.scss";

const InboundDocument: FC<InboundDocumentProps> = ({ match }) => {
  return (
    <AICLayout
      disableCountryChange
      fixedCountry={match.params.countryCode}
      disableUrlSearchParamsUpdate
    >
      <InboundDocumentContextProvider>
        <InboundDocumentFetcher
          countryCode={match.params.countryCode}
          documentId={match.params.documentId}
          documentType={match.params.documentType}
        />
        <DocumentComplianceContextProvider>
          <ValidationResultsContextProvider>
            <UserActionsMetadataContextProvider>
              <DocumentComplianceHelperProvider>
                <div className={styles.ma_10}>
                  <InboundDocumentHeader />
                  <InboundDocumentNavbar
                    inboundDocumentTab={match.params.inboundDocumentTab}
                  />
                </div>
                <DocumentComplianceHelperPanel />
              </DocumentComplianceHelperProvider>
            </UserActionsMetadataContextProvider>
          </ValidationResultsContextProvider>
        </DocumentComplianceContextProvider>
      </InboundDocumentContextProvider>
    </AICLayout>
  );
};

export default InboundDocument;

type InboundDocumentProps = RouteComponentProps<InboundDocumentPageRequest>;
